<template>
  <Nav-bar :has_back="true" :has_right="false" title="电桩详情"></Nav-bar>
  <div class="top-margin"></div>

  <!-- 挪车通知悬浮栏 -->
  <div class="move-car-notice" v-if="state.occupancyRule != null">
    <img src="@/images/tip_withdrawal.png" style="width:15px;height:15px;">
    <span class="notice-text">充电请及时挪车，超时将取占位费</span>
  </div>

  <div class="details-container">
    <!-- 电站名称和价格 -->
    <div class="station-price-card">
      <div class="station-info-section">
        <div class="station-header">
          <span class="station-category" :class="state.stationDetals.category">
            {{ categoryStatus[state.stationDetals.category] }}
          </span>
          <span class="station-name">{{ state.stationDetals.name }}</span>
        </div>
      </div>
      <div class="price-section" @click="toRate()">
        <span class="price-number">{{ state.currentPrice }}</span>
        <span class="price-unit">元/度</span>
        <div class="price-time-info">
          <span class="time-text">{{ getTimeSegmentText() }}</span>
        </div>
      </div>
    </div>

    <!-- 充电桩详情卡片 -->
    <div class="charger-detail-card">
      <div class="charger-icon-section">
        <div class="charger-icon-wrapper" :class="state.status">
          <div class="charger-icon">{{ getChargerIconText() }}</div>
        </div>
        <div class="charger-info">
          <div class="charger-name">{{ state.chargeName }}</div>
          <div class="charger-specs">
            <span>{{ state.chargeDetails.pile_type == "ac" ? "交流" : "直流" }}快充</span>
            <span class="separator">·</span>
            <span>{{ state.chargeDetails.rated_power }}kW</span>
            <span class="separator">·</span>
            <span>300V</span>
          </div>
        </div>
        <div class="charger-actions">
          <van-button class="unlock-btn" size="small" type="primary" v-if="showPay" @click="openLock">降锁</van-button>
        </div>
      </div>
    </div>

    <!-- 费用说明卡片 -->
    <div class="fee-info-card">
      <div class="fee-item">
        <div class="fee-icon">
          <img src="@/images/parking_icon.png" style="width: 20px; height: 20px;">
        </div>
        <div class="fee-text">
          <div class="fee-title">停车费</div>
          <div class="fee-desc">暂无</div>
        </div>
      </div>
      <div class="fee-item" v-if="state.occupancyRule != null">
        <div class="fee-icon">
          <img src="@/images/occupancy_icon.png" style="width: 20px; height: 20px;">
        </div>
        <div class="fee-text" v-if="state.occupancyRule != null">
          <div class="fee-title">超时占位费</div>
          <div class="fee-desc" v-if="isVattiDomainConfig">为了提升充电站充电效率，充电完成后请您及时驶离。我们为您预留了{{
            state.occupancyRule.grace_period_min }}分钟免费离场缓冲时间，超时后将按{{ state.occupancyRule.unit_price * 60
            }}元/小时收取占位费，单次最高收取10元
          </div>
          <div class="fee-desc" v-else>{{ state.occupancyRule.unit_price }}元/分钟，充电结束{{
            state.occupancyRule.grace_period_min }}分钟后收取{{
              state.occupancyRule.unit_price }}</div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <!-- <div class="tip" v-if="isVip">
        <img src="../../images/charge_vip.png" class="tip-icon" />
        <span>内部用户,该电桩享受免费充电权益</span>
      </div> -->
      <van-button type="primary" size="normal" :disabled="(state.status == 'charging' && !isSelfOrder) ||
        state.status == 'offline' ||
        btnLock
        " class="start-charge-btn" @click="startEle()">{{ state.btnValue }}</van-button>

    </div>

    <!-- <div class="lock" v-if="state.chargeLock != ''">
      <span class="t-f14-c66"
        >降锁没有成功？<span class="t-f14-c0082ff" @click="openLock"
          >重新开锁</span
        ></span
      >
    </div> -->

    <div class="unpaid-lab" v-if="isHasUnpaid" @click="toOrderList">
      <img src="../../images/unpaid_tip.png" />
      <span> 当前有未支付订单,请尽快支付!</span>
      <img src="../../images/disclosure.png" class="right-icon" />
    </div>
  </div>
  <van-popup teleport="body" round closeable close-icon-position="top-right" v-model:show="showPay"
    :style="{ width: '90%' }">
    <div class="pop-container column">
      <span class="t-f16-c0082ff center">请选择充电金额</span>
      <span class="t-f12-c66 m-t-20">本次可充值金额最高不超过50000元</span>
      <div class="grid-container">
        <div class="bg-v">
          <van-grid :gutter="10" column-num="3">
            <van-grid-item>
              <span class="grid-item-v t-f14-c28 font-bold" :class="indexCode == 30 && 'selected'"
                @click="cutIndex(30)">30元</span>
            </van-grid-item>

            <van-grid-item>
              <span class="grid-item-v t-f14-c28 font-bold" :class="indexCode == 50 && 'selected'"
                @click="cutIndex(50)">50元</span>
            </van-grid-item>
            <van-grid-item>
              <span class="grid-item-v t-f14-c28 font-bold" :class="indexCode == 100 && 'selected'"
                @click="cutIndex(100)">100元</span>
            </van-grid-item>
            <van-grid-item>
              <span class="grid-item-v t-f14-c28 font-bold" :class="indexCode == 200 && 'selected'"
                @click="cutIndex(200)">200元</span>
            </van-grid-item>
            <van-grid-item>
              <span class="grid-item-v t-f14-c28 font-bold" :class="indexCode == 300 && 'selected'"
                @click="cutIndex(300)">300元</span>
            </van-grid-item>
            <van-grid-item>
              <div class="grid-item-v" :class="indexCode == 0 && 'selected'" @click="cutIndex(0)">
                <van-field class="input-sytle" v-model="chargeValue" placeholder="输入金额" maxlength="5" type="number" />
              </div>
            </van-grid-item>
          </van-grid>
        </div>
        <div class="m-t-20">
          <span class="t-f12-c66">请选择支付方式</span>
          <div class="pay-type m-t-15">
            <img src="../../images/payment_wechat.png" class="wechat" />
            <span class="wechat-font">微信钱包</span>
            <img src="../../images/wechat_choose.png" class="wechat_c" />
          </div>
        </div>
        <div class="m-20">
          <van-button type="primary" size="normal" class="main-btn" @click="toWxPay">充值</van-button>
          <div class="t-f10-cfb0006 m-t-10 center">
            电桩最低启动金额为{{ turnOnBalance }}元，充电完成剩余金额会原路退回
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>


<script>
import NavBar from "../../components/NavBar.vue";
import { Toast } from "vant";
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import request from "@/api/request";
import ordersData from "@/utils/data.js";
import httpHelper from "@/helpers/http_helper";
import tokenHelper from "@/helpers/token_helper";
import wx from "weixin-js-sdk";
import { useStore } from "vuex";
import config from "@/api/config";
let stateContext;
let isHasUnpaid = ref(false);
let router;
let isVip;
let state = "";
let chargeValue;
let indexCode;
let btnLock;
let isSelfOrder = ref(false);
let ordersId = "";
let price = ref(50);
let showPay = ref(false);
let serviceProviderId;
let turnOnBalance = ref(0);
let balance = ref(0);
let isVattiDomainConfig = ref(false);
export default {
  components: {
    NavBar: NavBar,
  },

  setup() {
    isVattiDomainConfig.value = config.baseUrl.dev.includes("vatti-webapp.lcola.cn");
    isSelfOrder = ref(false);
    chargeValue = ref("");
    indexCode = ref(50);
    state = reactive({
      chargeId: "",
      statusName: "",
      chargeName: "",
      btnValue: "开始充电",
      occupancyRule: null,
    });
    const categoryStatus = {
      self_run: "自营",
      info: "第三方",
      third_party: "第三方",
    };

    const active = ref(0);
    router = useRouter();
    isVip = ref(false);
    btnLock = ref(false);
    stateContext = useStore();
    setWxConfig();
    apiChargeDetails();
    if (tokenHelper.readAccessToken() != null) {
      checkUnpaidOrder();
      getUserInfoBalance();
      checkVip();
    }

    function toRate() {
      const id = router.currentRoute.value.params.id
      router.push(`/station/Rate/${id}`);
    }
    //跳转充电订单
    function toOrderList() {
      router.push("/user/orders_list");
    }
    function startEle() {
      btnLock.value = true;
      if (isSelfOrder.value) {
        router.push("/station/Charging/" + ordersId);
        return;
      }
      btnLock.value = false;
      if (turnOnBalance.value != "") {
        if (balance.value < turnOnBalance.value) {
          showPay.value = true;
        } else {
          reuqestStartApi();
        }
        return;
      }
      reuqestStartApi();
    }
    function openLock() {
      Toast.loading({
        message: "降锁中...",
        loadingType: "spinner",
        icon: "bulb-o",
        forbidClick: true,
      });
      request.putOpenLock(state.lockId).then((res) => {
        if (!res.data.result) {
          Toast("降锁异常!");
        }
      });
    }

    function getChargerIconText() {
      switch (state.status) {
        case 'available':
          return '空闲';
        case 'charging':
          return '充电';
        case 'offline':
          return '离线';
        case 'maintaining':
          return '维护';
        default:
          return '空闲';
      }
    }

    return {
      state,
      active,
      toRate,
      isHasUnpaid,
      isSelfOrder,
      categoryStatus,
      toOrderList,
      cutIndex,
      router,
      turnOnBalance,
      balance,
      startEle,
      isVip,
      toWxPay,
      showPay,
      chargeValue,
      indexCode,
      serviceProviderId,
      openLock,
      getChargerIconText,
      getTimeSegmentText,
      isVattiDomainConfig,
    };
  },
};
function getUserInfoBalance() {
  request.getUserInfo().then((res) => {
    balance.value = res.data.balance;
  });
}
function checkVip() {
  request.getVerifyVipUse(router.currentRoute.value.params.id).then((res) => {
    if (res.data.vip_user) {
      console.log(",,,,,", res.data)
      isVip.value = true
    }
  });
}
function apiChargeDetails() {
  httpHelper.showLoading();
  request
    .getChargersDetails(router.currentRoute.value.params.id)
    .then((res) => {
      httpHelper.hideLoading();
      turnOnBalance.value = res.data.minimum_turn_on_balance;
      serviceProviderId = res.data.charging_pile.service_provider.id;
      state.statusName = ordersData.chargeStatus(res.data.status);
      // state.chargeLock = res.data.charging_station_parking_lock;
      state.lockId = res.data.charging_station_parking_lock.id;
      state.status = res.data.status;
      state.chargeId = res.data.id;
      state.chargeName = res.data.charging_pile.serial_number + " " + res.data.name;
      state.occupancyRule = res.data.occupancy_rule || null;

      state.chargeDetails = res.data.charging_pile;
      state.billingRules = res.data.billing_rules;
      state.stationDetals = res.data.charging_pile.charging_station;
      const timeInfo = getCurrentTimeRules(res.data.billing_rules[0].rule);
      state.currentPrice = timeInfo.currentPrice;
      state.currentTimeSegment = timeInfo.currentSegment;
      state.nextTimeSegment = timeInfo.nextSegment;
      if (res.data.status == "charging") {
        request.checkPendingOrder().then((res) => {
          let array = res.data.results;
          if (array.length != 0) {
            for (let index = 0; index < array.length; index++) {
              const element = array[index];
              if (state.chargeId == element.charger.id) {
                ordersId = element.id;
                isSelfOrder.value = true;
                state.btnValue = "查看充电详情";
              }
            }
          }
        });
      }
    })
    .catch(() => {
      httpHelper.hideLoading();
    });
}
//注入微信公众号权限验证配置
function setWxConfig() {
  request
    .getWxConfigInfo({ escaped_url: encodeURIComponent(window.location.href) })
    .then((res) => {
      let data = res.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ["chooseWXPay", "checkJsApi"], // 必填，需要使用的JS接口列表
      });
    });
}
function toWxPay() {
  let priceNumber = 50;
  if (indexCode.value != 0) {
    priceNumber = indexCode.value;
  }
  if (indexCode.value == 0) {
    priceNumber = chargeValue.value;
  }

  if (priceNumber < turnOnBalance.value) {
    Toast("单次充值最低为" + turnOnBalance.value + "元");
    return;
  }
  if (priceNumber > 5000) {
    Toast("单次充值最高为5000元");
    return;
  }
  price.value = priceNumber;
  request
    .directWxPay({
      price: priceNumber * 100,
      // service_provider_id: serviceProviderId,
    })
    .then((res) => {
      let payData = res.data.body;
      stateContext.commit("setChargeId", state.chargeId);
      wx.chooseWXPay({
        timestamp: payData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: payData.nonceStr, // 支付签名随机串，不长于 32 位
        package: payData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: payData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: payData.paySign, // 支付签名
        success: function () {
          request
            .postWebCheckPayOrders({ out_trade_no: res.data.out_trade_no })
            .then((success) => {
              if (success.data.result == "success") {
                reuqestStartApi();
              }
            });
        },
      });
    });
}
function reuqestStartApi() {
  request.putStartCharge(state.chargeId).then((res) => {
    if (res.data.status == "success") {
      router.push(`/station/staring_charging/${res.data.id}`);
    }
  });
}
// function checkUsePermissions(id) {
//   request.getUserPermissions(id).then((res) => {
//     isVip.value = !res.data.result;
//   });
// }
function getCurrentTimeRules(array) {
  const now = new Date();
  const currentTime = now.getHours().toString().padStart(2, '0') + ":" + now.getMinutes().toString().padStart(2, '0');

  let currentSegment = null;
  let currentIndex = -1;

  // 查找当前时间段
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if (isTimeInRange(currentTime, element.from, element.to)) {
      currentSegment = element;
      currentIndex = index;
      break;
    }
  }

  // 如果没找到当前时间段，使用第一个作为默认
  if (!currentSegment) {
    currentSegment = array[0];
    currentIndex = 0;
  }

  // 获取下一个时间段
  const nextIndex = (currentIndex + 1) % array.length;
  const nextSegment = array[nextIndex];

  const currentPrice = parseFloat(currentSegment.power_rate) + parseFloat(currentSegment.service_rate);

  return {
    currentPrice: currentPrice.toFixed(2),
    currentSegment: currentSegment,
    nextSegment: nextSegment
  };
}

// 判断时间是否在指定范围内
function isTimeInRange(currentTime, fromTime, toTime) {
  const current = timeToMinutes(currentTime);
  const from = timeToMinutes(fromTime);
  const to = timeToMinutes(toTime);

  // 处理跨天的情况（如22:01到09:01）
  if (from > to) {
    return current >= from || current <= to;
  } else {
    return current >= from && current <= to;
  }
}

// 将时间转换为分钟数便于比较
function timeToMinutes(timeStr) {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
}

// 获取时间段显示文本
function getTimeSegmentText() {
  if (!state.currentTimeSegment || !state.nextTimeSegment) {
    return '当前时段 --:-- - --:--，下一时段 --元/度 >';
  }

  const currentFrom = state.currentTimeSegment.from;
  const currentTo = state.currentTimeSegment.to;
  const nextPrice = (parseFloat(state.nextTimeSegment.power_rate) + parseFloat(state.nextTimeSegment.service_rate)).toFixed(2);

  return `当前时段 ${currentFrom}-${currentTo}，下一时段 ${nextPrice}元/度 >`;
}
function checkUnpaidOrder() {
  let param = {};
  param["status"] = "unpaid";
  request.getOrderList(param).then((res) => {
    isHasUnpaid.value = res.data.results.length != 0;
  });
}
//选择金额
function cutIndex(index) {
  //重置输入框
  if (index !== 0) {
    chargeValue.value = "";
  }
  indexCode.value = index;
}
</script>

<style lang="scss" scoped>
.t-f10-cfb0006 {
  font-size: 10px;
  color: #fb0006;
}

.wechat-font {
  margin-left: 10px;
  font-size: 14px;
  color: #282828;
}

.wechat_c {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
}

.wechat {
  width: 30px;
  height: 30px;
  vertical-align: middle;
}

.pay-type {
  position: relative;
  border-radius: 10px;
  border: 1px solid #eee;
  padding: 10px;
}

.t-f14-c28 {
  font-size: 14px;
  color: #282828;
}

.grid-container {
  margin-top: 10px;
}

.bg-v {
  border-radius: 5px;
  margin-top: 5px;
}

.line {
  background: #efefef;
  height: 1px;
  margin: 15px 0px;
}

.grid-item-v {
  border-radius: 8px;
  line-height: 40px;
  height: 40px;
  border: 1px solid #e0e0e0;
  text-align: center;
  width: 100%;
}

.selected {
  background: #f19321;
  color: #fff;
  border: none;
}

.center {
  text-align: center;
}

.column {
  display: flex;
  flex-direction: column;
}

.t-f16-c0082ff {
  font-size: 16px;
  color: #0082ff;
}

.tip-icon {
  width: 12px;
  height: 13px;
  margin: auto 0;
  margin-right: 10px;
}

.tip {
  margin: 0px auto;
  color: #fb0006;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  padding: 10px;
}

/* 挪车通知悬浮栏 */
.move-car-notice {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  background: #FFF9F2;
  color: #F19321;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 999;
}


.notice-text {
  font-size: 12px;
  font-weight: 500;
}

.details-container {
  position: relative;
  padding: 15px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* 电站名称和价格合并卡片（渐变色背景） */
.station-price-card {
  background: linear-gradient(to bottom, #FFFAF4 0%, #E9F8FF 100%);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 0;
  color: #1a1a1a;
}

.station-info-section {
  margin-bottom: 16px;
}

.station-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.station-name {
  font-size: 18px;
  font-weight: 600;
}

.station-category {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.station-info-section .station-category {
  background: rgba(255, 255, 255, 0.2);
  color: #0082FF;
  padding: 2px 5px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}

.station-info-section .station-name {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.price-section {
  text-align: left;
  width: 100%;
}

.price-main {
  margin-bottom: 8px;
}

.price-number {
  font-size: 32px;
  font-weight: 700;
}

.price-unit {
  font-size: 16px;
  margin-left: 4px;
}

.price-time-info {
  display: flex;
  align-items: center;
  opacity: 0.9;
}

.time-icon {
  margin-right: 6px;
  font-size: 14px;
}

.time-text {
  font-size: 14px;
  color: #666666;
}

.price-section .price-main {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  margin-bottom: 8px;
}

.price-section .price-number {
  font-size: 42px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1;
}

.price-section .price-unit {
  font-size: 18px;
  color: #1a1a1a;
  font-weight: 500;
}

.price-section .price-time-info {
  margin-top: 8px;
}

.price-section .time-text {
  font-size: 12px;
}

/* 充电桩详情卡片 */
.charger-detail-card {
  background: #fff;
  border-radius: 0 0 16px 16px;
  padding: 16px;
  margin-bottom: 12px;
  border-top: 1px solid #e0e0e0;
}

.charger-icon-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.charger-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #00b68a;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.charger-icon-wrapper.available {
  border-color: #00b68a;
}

.charger-icon-wrapper.charging {
  border-color: #ff8f00;
}

.charger-icon-wrapper.offline {
  border-color: #999999;
}

.charger-icon-wrapper.maintaining {
  border-color: #fb0006;
}

.charger-icon {
  font-size: 12px;
  color: #00b68a;
  font-weight: 500;
}

.charger-icon-wrapper.available .charger-icon {
  color: #00b68a;
}

.charger-icon-wrapper.charging .charger-icon {
  color: #ff8f00;
}

.charger-icon-wrapper.offline .charger-icon {
  color: #999999;
}

.charger-icon-wrapper.maintaining .charger-icon {
  color: #fb0006;
}

.charger-info {
  flex: 1;
}

.charger-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.charger-specs {
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.separator {
  color: #ccc;
}

.charger-actions {
  display: flex;
  align-items: center;
}

.unlock-btn {
  background: #1890ff;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 12px;
  padding: 4px 12px;
}

/* 费用说明卡片 */
.fee-info-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

.fee-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.fee-item:last-child {
  margin-bottom: 0;
}

.fee-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.fee-text {
  flex: 1;
}

.fee-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.fee-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* 按钮容器 */
.button-container {
  padding: 20px 15px;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #f0f0f0;
}

.start-charge-btn {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.start-charge-btn:disabled {
  background: #d9d9d9;
  color: #999;
  box-shadow: none;
}

.lock {
  text-align: center;
  font-size: 14px;
}

.t-f14-c0082ff {
  color: #0082ff;
}

.t-f14-c66 {
  color: #666;
}

.info-container {
  text-align: center;
}

.tip-bolck {
  border: 1px solid #0082ff;
  color: #0082ff;
  height: 20px;
  flex-shrink: 0;
}

.item-bock {
  height: 18px;
  line-height: 18px;
  border-radius: 5px;
  padding: 2px 2px 0px 2px;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 100px;
  text-align: center;
  border-radius: 5px;
  background-color: #39a9ed;
}

.charge-list-container {
  border-radius: 5px;
  background: #fff;
  margin: 20px 10px;
}

.item-list {
  border-bottom: 1px solid #ebebeb;
  line-height: 50px;
  align-items: center;
  margin: 0px 10px;
  position: relative;
}

.tabs-list {
  margin: 10px;
  border-radius: 10px;
  line-height: 40px;
  align-items: center;
}

.center {
  text-align: center;
  display: grid;
}

.available {
  color: #00b68a !important;
}

.offline {
  color: #999999 !important;
}

.charged {
  color: #0082ff !important;
}

.maintaining {
  color: #fb0006 !important;
}

.charging {
  color: #ff8f00 !important;
}

.tab-icon {
  vertical-align: middle;
}

.pop-container {
  padding: 20px 20px 10px 20px;
}

::v-deep .van-grid-item__content {
  padding: 0 !important;
}

::v-deep.van-tabs__nav--card {
  border: none;
}

::v-deep.van-tabs__nav--card {
  margin: 0;
  height: 40px;
  line-height: 40px;
}

::v-deep.van-tab {
  border: none;
}

::v-deep.van-tabs__wrap {
  height: 40px;
  border-radius: 5px;
  line-height: 40px;
  align-items: center;
}

::v-deep.van-swipe {
  width: 130px;
}

::v-deep.van-grid {
  padding-left: 0px !important;
}

::v-deep.van-tabs__nav--card .van-tab {
  color: #1a1a1a;
}

::v-deep.van-tabs__nav--card .van-tab.van-tab--active {
  border-color: none;
  color: #0082ff;
  background: rgba(6, 167, 255, 1);
}

.defult-station {
  width: 120px;
  height: 100px;
}

.row {
  display: flex;
  flex-direction: row;
}

.unpaid-lab {
  z-index: 999;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  padding: 10px 15px;
  align-items: center;
  justify-items: center;
  background: #fff6f6;
}

.unpaid-lab img {
  width: 15px;
  height: 15px;
  margin: auto 0;
  vertical-align: middle;
}

.unpaid-lab span {
  color: #fb0006;
  font-size: 14px;
}

.right-icon {
  width: 22px !important;
  height: 22px !important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
}
</style>
